module.exports = __webpack_public_path__ + "img/step4-en@2x.f2ac2bc4.webp";